import script from "./DiagnosisScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosisScreen.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__